// Mock data for Ess Bee Heaters Pvt. Ltd. clone

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1920&q=80&auto=format&fit=crop",
    tagline: "Engineered Heat. Endless Possibilities.",
    title: "Industrial Infrared Heating, Reimagined",
    subtitle: "Built for performance. Designed for endurance. Tailored for your industry.",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1920&q=80&auto=format&fit=crop",
    tagline: "Next-Gen Manufacturing",
    title: "Smart Heaters For Modern Production Lines",
    subtitle: "Faster cycle times, lower energy bills, uncompromising quality control.",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1605557202138-4d4f7f93b6a7?w=1920&q=80&auto=format&fit=crop",
    tagline: "Custom Built For You",
    title: "Bespoke Heating Systems — Your Specs, Our Craft",
    subtitle: "From single-wattage units to full production-line solutions, we engineer it.",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=1920&q=80&auto=format&fit=crop",
    tagline: "Global Standards. Local Roots.",
    title: "Trusted By 1000+ Industries Worldwide",
    subtitle: "ISO 9001:2015 certified manufacturing with full quality traceability.",
  },
];

export const tickerItems = [
  "ISO 9001:2015 Certified",
  "RoHS Compliant",
  "CE Certified",
  "Made in India",
  "25+ Years of Excellence",
  "OEM & Custom Solutions",
  "In-House R&D Lab",
  "Pan India Delivery",
];

export const stats = [
  { value: "25+", label: "Years of Excellence" },
  { value: "2+", label: "Product Range" },
  { value: "1000+", label: "Happy Clients" },
  { value: "100%", label: "Quality Assurance" },
];

export const certifications = [
  { title: "ISO 9001:2015", subtitle: "Quality Management", icon: "Award" },
  { title: "RoHS Compliant", subtitle: "Environment Safe", icon: "Flame" },
  { title: "CE Marked", subtitle: "European Standards", icon: "ShieldCheck" },
  { title: "MSME Registered", subtitle: "Govt. of India", icon: "Award" },
];

export const processSteps = [
  { step: "01", title: "Requirement", desc: "Understanding client needs and specs", icon: "Search" },
  { step: "02", title: "Design", desc: "Custom engineering & prototyping", icon: "Wrench" },
  { step: "03", title: "Manufacturing", desc: "Precision in-house production", icon: "Settings" },
  { step: "04", title: "Testing", desc: "Multi-stage QA in our lab", icon: "FlaskConical" },
  { step: "05", title: "Delivery", desc: "Pan-India and global dispatch", icon: "Truck" },
];

export const whyChooseUs = [
  { title: "ISO Certified", icon: "BadgeCheck" },
  { title: "In-House Mfg", icon: "Factory" },
  { title: "Quality Tested", icon: "ShieldCheck" },
  { title: "Expert Team", icon: "Users" },
  { title: "High Efficiency", icon: "Zap" },
  { title: "Tailor Made", icon: "Cog" },
];

export const products = [
  {
    slug: "shortwave-ir-heater",
    name: "Shortwave IR Heater",
    image: "https://essbeeheaters.com/uploads/94268e1634304bf88b1e7469e765f4b8.jpg",
    short: "High-performance shortwave infrared heaters for industrial drying, curing, and heating processes.",
    description:
      "Our shortwave IR heaters are engineered for high performance and long service life across industrial applications. Manufactured using premium-grade materials and rigorously tested in our in-house laboratory to meet international standards.",
    features: [
      "High efficiency heat transfer",
      "Custom sizes and wattages available",
      "Corrosion resistant construction",
      "Long service life",
      "ISO 9001:2015 certified quality",
      "Rapid heating response time",
      "Energy efficient operation",
      "Wide temperature range",
    ],
    applications: [
      "Industrial drying processes",
      "Plastic thermoforming",
      "Paint curing",
      "Food processing",
      "Textile manufacturing",
      "Automotive industries",
    ],
  },
  {
    slug: "shortwave-ir-heaters-with-reflector-box",
    name: "Shortwave IR Heaters with Reflector Box",
    image: "https://essbeeheaters.com/uploads/64d4653902584e239e65b053f247e610.jpg",
    short: "Enclosed shortwave IR heaters with precision aluminum reflector box for directional heating.",
    description:
      "Shortwave IR heaters housed in a precision-engineered reflector box for directional, efficient heat delivery. Ideal for focused industrial drying and curing applications where targeted heating is essential.",
    features: [
      "Polished aluminum reflector for maximum output",
      "Sturdy housing for industrial environments",
      "Custom dimensions on request",
      "Concentrated directional heating",
      "Easy installation & maintenance",
      "Heat output up to 220 kW/m\u00b2",
      "Adjustable mounting angles",
      "Compatible with PLC control",
    ],
    applications: [
      "PET preform heating",
      "Plastic blow moulding",
      "Powder coating cure",
      "Laminating lines",
      "Paper & printing dryers",
      "Automotive paint shops",
    ],
  },
];

export const testimonials = [
  {
    name: "Mayank Khandelwal",
    role: "Procurement Manager",
    quote: "Best quality products at affordable prices. Loved the variety of heaters they offer.",
  },
  {
    name: "Deepak Shukla",
    role: "Plant Engineer",
    quote: "Very good heaters available here. The quality is excellent and prices are reasonable.",
  },
  {
    name: "Vivek Kumar",
    role: "Operations Lead",
    quote: "Nice range of industrial heating elements with consistent quality.",
  },
  {
    name: "Amar Kushwaha",
    role: "Buyer",
    quote: "Quality products with reasonable prices and great customer service.",
  },
];

export const industries = [
  "OEMs",
  "Food Processing",
  "Textiles",
  "Plastic Industry",
  "Rubber Industry",
  "Chemical & Pharmaceutical",
  "Electroplating",
  "Fertilizer Plants",
  "PET Industries",
  "Foam Plant",
  "Packaging Industries",
];

export const gallery = [
  "https://essbeeheaters.com/uploads/94268e1634304bf88b1e7469e765f4b8.jpg",
  "https://essbeeheaters.com/uploads/64d4653902584e239e65b053f247e610.jpg",
];

export const contact = {
  phone: "+91-9911565091",
  emails: [
    "info.essbeeheaters@gmail.com",
    "ess_beeheat@yahoo.com",
    "sunilbansal151@gmail.com",
  ],
  location: "Delhi, India",
  hours: "Mon - Sat  |  9:00 AM - 6:00 PM",
  whatsapp: "919911565091",
  youtubeId: "csjwGW3j2RU",
};
